<script lang="ts">
	import { Button } from "#lib/web-ui/ui/button/index.js";
	import HeroBase from "./hero-base.svelte";
	import { heroDefaults, type HeroImageBackgroundProps } from "./hero.types";

	let {
		imageUrl,
		imageAlt = heroDefaults.imageAlt,
		...baseProps
	}: HeroImageBackgroundProps = $props();
</script>

<HeroBase {...baseProps}>
	{#snippet children({ title, subtitle, badge, cta, secondaryCta })}
		<section class="bg-foreground relative isolate overflow-hidden pt-14">
			<img
				src={imageUrl}
				srcset={imageUrl.includes("cloudinary.com")
					? `${imageUrl.replace(/w_\d+/, "w_400")} 400w, ${imageUrl.replace(/w_\d+/, "w_800")} 800w, ${imageUrl.replace(/w_\d+/, "w_1200")} 1200w`
					: undefined}
				sizes="100vw"
				alt={imageAlt}
				class="absolute inset-0 -z-20 size-full object-cover opacity-30"
				fetchpriority="high"
				width="1200"
				height="800"
				loading="eager"
			/>
			<div class="bg-primary/50 absolute inset-0 -z-10"></div>

			<div class="mx-auto max-w-5xl px-6 lg:px-8">
				<div class="mx-auto max-w-3xl py-16 sm:py-24 lg:py-32">
					{#if badge}
						<div class="mb-8 flex justify-center">
							{#if badge.href}
								<a
									href={badge.href}
									class="bg-background/10 text-primary-foreground ring-background/20 hover:ring-background/40 rounded-full px-4 py-1.5 text-sm font-medium ring-1 transition"
								>
									{badge.text}
								</a>
							{:else}
								<span
									class="bg-background/10 text-primary-foreground ring-background/20 rounded-full px-4 py-1.5 text-sm font-medium ring-1"
								>
									{badge.text}
								</span>
							{/if}
						</div>
					{/if}

					<div class="text-center">
						<h1
							class="text-primary-foreground text-4xl font-semibold tracking-tight text-balance sm:text-6xl"
						>
							{title}
						</h1>

						{#if subtitle}
							<p
								class="text-primary-foreground/80 mt-8 text-lg font-medium text-pretty sm:text-xl/8"
							>
								{subtitle}
							</p>
						{/if}

						{#if cta || secondaryCta}
							<div class="mt-10 flex flex-wrap items-center justify-center gap-4">
								{#if cta}
									<Button href={cta.href} size="lg" variant="secondary">
										{cta.label}
									</Button>
								{/if}
								{#if secondaryCta}
									<Button
										href={secondaryCta.href}
										size="lg"
										variant="ghost"
										class="border border-white/60 text-white hover:border-white hover:bg-white/10 hover:text-white"
									>
										{secondaryCta.label}
									</Button>
								{/if}
							</div>
						{/if}
					</div>
				</div>
			</div>
		</section>
	{/snippet}
</HeroBase>
